<template>
  <template v-if="mainLayout">
    <HeaderComponent />
    <div class="container-padding">
      <div id="content">
        <AsideComponent v-if="mainLayout" />
        <RouterView :key="route.fullPath" />
      </div>
    </div>
  </template>
  <RouterView v-else :key="route.fullPath" />
  <ModalComponent />
</template>

<script setup>
import { ModalComponent } from "@/components/ui";
import { useRoute } from "vue-router";
import { AsideComponent, HeaderComponent } from "@/components/layout";
import { computed } from "vue";

const route = useRoute();

const mainLayout = computed(() => route.meta?.layout === "main");
</script>

<style lang="stylus">
// Глобальные стили теперь импортируются в main.js
</style>
